import {Allow, parse} from 'partial-json'

export interface Question {
  question_topic: string
  answers: string[]
}

export interface RawQuestionData {
  type: 'question'
  data: Question
}

const JSON_MARK = '```json\n'

const QUESTION_BEGIN_TEXT = `${JSON_MARK}{\n    "question_topic"`

const QUESTION_END_TEXT = '\n```'

export default function splitQuestionFromMessage(message: string): (string | RawQuestionData)[] {
  // Looking for begin of question
  const beginQuestionPos = message.indexOf(QUESTION_BEGIN_TEXT)
  if (beginQuestionPos !== -1) {
    // Found question section
    const messageBeforeQuestion = message.slice(0, beginQuestionPos)
    const messageQuestionAndMaybeMore = message.slice(beginQuestionPos + JSON_MARK.length)
    const endQuestionPos = messageQuestionAndMaybeMore.indexOf(QUESTION_END_TEXT)

    if (endQuestionPos !== -1) {
      // Found everything

      const rawQuestion = parse(
        messageQuestionAndMaybeMore.slice(0, endQuestionPos),
        Allow.ALL,
      ) as Question

      const question: RawQuestionData = {
        type: 'question',
        data: rawQuestion,
      }

      const messageAfterQuestion = messageQuestionAndMaybeMore.slice(
        endQuestionPos + QUESTION_END_TEXT.length,
      )
      return [messageBeforeQuestion, question, ...splitQuestionFromMessage(messageAfterQuestion)]
    }
    // Found partial
    const rawQuestion = parse(messageQuestionAndMaybeMore, Allow.ALL) as Question
    const question: RawQuestionData = {
      type: 'question',
      data: rawQuestion,
    }
    return [messageBeforeQuestion, question]
  }
  // cannot found any question
  // console.log('Cannot find any more question', [message])
  return [message].filter(Boolean)
}
